"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareExposedPadPins = compareExposedPadPins;
function compareExposedPadPins(customerPin, packagePin, pinCount) {
    if (!customerPin || customerPin.size === 0 || !packagePin) {
        return false;
    }
    const exposedPadPatterns = ['0', `${pinCount}`, 'ep', 'pad', 'epad'];
    if (Array.from(packagePin).every((pin) => {
        return exposedPadPatterns.includes(pin.toLowerCase());
    }) &&
        Array.from(customerPin).every((pin) => {
            return exposedPadPatterns.includes(pin.toLowerCase());
        })) {
        return true;
    }
    return false;
}
//# sourceMappingURL=compareExposedPad.js.map